import React from "react";

import Label, { LabelProps } from "@stadium/ui/src/components/form/Label";

import styles from "./main.module.scss";

const FormLabel: React.FC<LabelProps> = (props) => <Label styles={styles} {...props} />;

export default FormLabel;
